export default __webpack_public_path__ + "static/media/Treated_Water_Tanks.fb2ba37a.jpg";